export type ParsedQuery =
  | { kind: "flight"; value: string }
  | { kind: "route"; from: string; to: string }
  | { kind: "airport"; code: string }
  | { kind: "airport-search"; q: string }
  | { kind: "empty" };

const FLIGHT_RE = /^[A-Z]{2,3}\d{1,5}[A-Z]?$/;
const ROUTE_RE = /^([A-Z]{3,4})\s*(?:-|→|\/|to|→| )\s*([A-Z]{3,4})$/i;
const CODE_RE = /^[A-Z]{3,4}$/;

export function parseQuery(input: string): ParsedQuery {
  const raw = input.trim();
  if (!raw) return { kind: "empty" };
  const upper = raw.toUpperCase().replace(/\s+/g, " ");
  // route: "ARN-LHR", "ARN LHR", "ARN→LHR"
  const m = upper.match(ROUTE_RE);
  if (m) return { kind: "route", from: m[1], to: m[2] };
  const parts = upper.split(/[\s,/→-]+/).filter(Boolean);
  if (parts.length === 2 && CODE_RE.test(parts[0]) && CODE_RE.test(parts[1])) {
    return { kind: "route", from: parts[0], to: parts[1] };
  }
  const compact = upper.replace(/\s+/g, "");
  if (FLIGHT_RE.test(compact)) return { kind: "flight", value: compact };
  if (CODE_RE.test(compact)) return { kind: "airport", code: compact };
  return { kind: "airport-search", q: raw };
}

export function navigateForQuery(parsed: ParsedQuery): string | null {
  switch (parsed.kind) {
    case "flight": return `/flight/${encodeURIComponent(parsed.value)}`;
    case "route": return `/route/${parsed.from}-${parsed.to}`;
    case "airport": return `/airport/${parsed.code}`;
    default: return null;
  }
}